import React from 'react';
import {
  AppstoreOutlined,
  CheckSquareOutlined,
  FolderOpenOutlined,
  FormOutlined,
  PaperClipOutlined,
  ReadOutlined,
} from '@ant-design/icons';
import ArtifactsTab from '../ArtifactsTab/ArtifactsTab';
import ClaimsTab from '../ClaimsTab/ClaimsTab';
import EscFilesList from '../FilesList/FilesList';
import TasksTab from '../TasksTab/TasksTab';
import WikiTab from '../WikiTab/WikiTab';
import type { SegmentTab } from './tabs';
import styles from './DossierRightPane.module.scss';

export const TAB_META: Record<
  SegmentTab,
  { icon: React.ReactNode; labelPath: string; fallback: string }
> = {
  context: {
    icon: <ReadOutlined />,
    labelPath: 'esc.tabs.context',
    fallback: 'Context',
  },
  tasks: {
    icon: <CheckSquareOutlined />,
    labelPath: 'esc.tabs.tasks',
    fallback: 'Tasks',
  },
  files: {
    icon: <PaperClipOutlined />,
    labelPath: 'esc.tabs.files',
    fallback: 'Files',
  },
  notes: {
    icon: <FormOutlined />,
    labelPath: 'esc.tabs.notes',
    fallback: 'Notes',
  },
  claims: {
    icon: <FolderOpenOutlined />,
    labelPath: 'esc.tabs.claims',
    fallback: 'Claims',
  },
  artifacts: {
    icon: <AppstoreOutlined />,
    labelPath: 'esc.tabs.artifacts',
    fallback: 'Artifacts',
  },
};

interface Props {
  dossierId: string;
  segment: SegmentTab;
  onFileClick: (fileId: string, page?: number) => void;
}

const DossierRightPane: React.FC<Props> = ({
  dossierId,
  segment,
  onFileClick,
}) => {
  return (
    <div className={styles.pane}>
      <div className={styles.body}>
        {segment === 'context' && <WikiTab dossierId={dossierId} />}
        {segment === 'tasks' && <TasksTab dossierId={dossierId} />}
        {segment === 'files' && (
          <EscFilesList kind="files" onFileClick={onFileClick} />
        )}
        {segment === 'notes' && (
          <EscFilesList kind="notes" onFileClick={onFileClick} />
        )}
        {segment === 'claims' && <ClaimsTab dossierId={dossierId} />}
        {segment === 'artifacts' && <ArtifactsTab dossierId={dossierId} />}
      </div>
    </div>
  );
};

export default DossierRightPane;
